import React, { useState, useEffect } from "react";
import { useParams, useNavigate  } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { Col, Row, Button, Table, InputGroup, FormControl, Card } from "react-bootstrap";
import moment from 'moment';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../Auth/apiService';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es, se } from 'date-fns/locale';
import { useAuth } from "../../Auth/AuthContext";
import SeccionPageHeader from "./../Utils/SeccionPageHeader";
import CargandoSpinner from "./../Utils/CargandoSpinner";
import { FaSearch, FaCalendar } from "react-icons/fa";
import { ConsultarPersonaDocumento } from "../../Auth/ConsultasApi";
registerLocale('es', es);
setDefaultLocale('es');

// CustomInput moved outside of Persona for best practices and prop validation
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
        <FaCalendar />
    </button>
));



export default function FormularioAlbergue(){    
    const { idFamilia } = useParams();
    const navigate = useNavigate();
    const { token, rol, sedeActual, user } = useAuth();
    const usrRolid = rol;
    const [cargando, setCargando] = useState(false);
    const [tipoDocumentos, setTipoDocumentos] = useState([]);
    const [pendingFormData, setPendingFormData] = useState(null);
    const [pendingPersonas, setPendingPersonas] = useState(null);
    const [parentescos, setParentescos] = useState([]);
    const [entidadesDeclaracion, setEntidadesDeclaracion] = useState([]);
    const [paises, setPaises] = useState([]);
    const [sexo, setSexo] = useState([]);
    const [redirectId, setRedirectId] = useState(null);
    const [estadosVictima, setEstadosVictima] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const [scannedCedula, setScannedCedula] = useState('');
    const [actaSalida, setActaSalida] = useState('');
    const {register, handleSubmit, control, setValue, reset, watch, formState: { errors }} = useForm();
    const estadovictima = watch('estadovictima');
    function resetForm(data = {}, personas = []) {
        setValue('fechaestado', moment().set({ hour: 12, minute: 0, second: 0 }).toISOString());
        setValue('perfechanac', moment().set({ hour: 12, minute: 0, second: 0 }).toISOString());
        if (!data) {
            return;
        }
        data.fechaestado = moment(data.fechaestado, 'YYYY-MM-DD', true).isValid()
            ? moment.utc(data.fechaestado.substr(0, 10)).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
            : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
        reset({
            id: data.id || null,
            usrId: user,
            fudFicha: data.fudFicha || '',
            tipodocumento: data.tipodocumento || '',
            documento: data.documento || '',
            primernombre: data.primernombre || '',   
            segundonombre: data.segundonombre || '',
            primerapellido: data.primerapellido || '',
            segundoapellido: data.segundoapellido || '',
            perPaisorigen: data.perPaisorigen || '',
            perIdParentesco: data.perIdParentesco || '',
            perFechanac: data.perfechanac
            ? moment(data.perfechanac).set({ hour: 12, minute: 0, second: 0 }).toISOString()
            : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString(),
            perSexo: data.perSexo || '',
            estadovictima: data.estadovictima || '',
            fechaestado: data.fechaestado
            ? moment(data.fechaestado).set({ hour: 12, minute: 0, second: 0 }).toISOString()
            : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString(),
            scannedCedula: data.scannedCedula || '',
            actaSalida: data.actaSalida || '',
            otraaltavulnerabilidadremisiones: data.otraaltavulnerabilidadremisiones || '',
        });
        setPersonas(personas);
    }
    
    function cancelarFamilia() {
        resetForm();
        navigate('/albergues/permanenciaalbergue');
    }
    
    const saveFamilia = async (data) => {
        setCargando(true);
        const url = '/albergue/guardarformularioingresoalbergue';
        data.usrId = user;
        await apiService.post(url, data, token)
        .then(response => {
            if (response.status === 200) {
                setRedirectId(response.data.declaraAlbergue.id); // <-- Guardar el id para redirigir
                setSwalProps({
                    show: true,
                    title: 'Guardar Formulario',
                    text: 'Guardado con éxito',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                });
            }
        })
        .catch(error => {
            if(error.status === 422){
                Mensaje('Guardar Formulario', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar Formulario', JSON.stringify(error.response.data.message));
            } else {
                Mensaje('Error', 'Ocurrió un error al crear el formulario de ingreso albergue.');
            }
            console.error('Error al guardar el formulario:', error);
        })
        .finally(() => {
            setCargando(false);
        });
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    useEffect(() => {
        if (tipoDocumentos.length > 0 && pendingFormData) {
            resetForm(pendingFormData, pendingPersonas);
            setPendingFormData(null);
            setPendingPersonas(null);
        }
    }, [tipoDocumentos, pendingFormData, pendingPersonas]);
    function crearFormularioRegistroIngresoAlbegue(idFamilia) {
        setCargando(true);
        const url = '/albergue/crearformularioingresoalbergue';
        const obj = { sede: sedeActual, usrRolid: usrRolid, idFamilia: idFamilia };
        apiService.post(url, obj, token)
            .then(response => {
                if (response.status === 200) {
                    setPaises(response.data.paises);
                    setParentescos(response.data.parentescos);
                    setSexo(response.data.sexos);
                    setEntidadesDeclaracion(response.data.entidadesdeclaracion)
                    setEstadosVictima(response.data.estadosvictima)
                    setPersonas(response.data.nucleoFamiliar);
                    setTipoDocumentos(response.data.tipoDocumentos)
                    setPendingFormData(response.data.declaraAlbergue);
                    setPendingPersonas(response.data.nucleoFamiliar);
                } else {
                    setSwalProps({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo cargar el formulario.'
                    });
                }
            })
            .catch(error => {
                console.error('Error al cargar el formulario:', error);
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al cargar el formulario.'
                });
            })
            .finally(() => {
                setCargando(false);
            });
    }
    async function buscaDeclaracion(fudFicha) {
        setCargando(true);
        const url = '/albergue/buscarficha';
        const obj = { usrRolid: usrRolid, fudFicha: fudFicha };
        await apiService.post(url, obj, token)
            .then(response => {
                if (response.status === 200) {
                    navigate(`/albergues/formularioalbergue/${response.data.ficha.id}`);
                } else {
                    setSwalProps({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se encontró la ficha.'
                    });
                }
            })
            .catch(error => {
                if(error.status === 422){
                    Mensaje('Consultar FUD', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Consultar FUD', JSON.stringify(error.response.data.message));
                } else {
                    Mensaje('Error', 'Ocurrió un error al crear el formulario de ingreso albergue.');
                }
                console.error('Error fetching data:', error);
            })
            .finally(() => {
                setCargando(false);
            });
    }
    useEffect(() => {
        if (idFamilia) {
            crearFormularioRegistroIngresoAlbegue(idFamilia);
        } else {
            resetForm();
        }
    }, [idFamilia]);

    const verImagen = (id, documento) => {
        const url = `cedulaAlbergue/${id}`;
        apiService.get(url, token, { responseType: 'blob' })
            .then((res) => {
            const content = res.headers['content-type'];
            download(res.data, `${documento}.pdf`, content);
            })
            .catch((error) => {
            console.log(error);
            });
    };

    const verImgSalida = (id, documento) => {
        const url = `actaSalida/${id}`;
        apiService.get(url, token, { responseType: 'blob' })
            .then((res) => {
            const content = res.headers['content-type'];
            download(res.data, `Acta_salida_${documento}.pdf`, content);
            })
            .catch((error) => {
            console.log(error);
            });
    };
    async function EliminarPersona(idPersona) {
        setCargando(true);
        const url = '/albergue/eliminarpersona';
        const obj = { id: idPersona };
        await apiService.post(url, obj, token)
            .then(response => {
                if (response.status === 200) {
                    setSwalProps({
                        show: true,
                        title: 'Eliminar Persona',
                        text: 'Persona eliminada con éxito',
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    });
                    setPersonas(prev => prev.filter(persona => persona.id !== idPersona));
                } else {
                    setSwalProps({
                        show: true,
                        title: 'Error',
                        text: 'No se pudo eliminar la persona.',
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch(error => {
                if(error.status === 422){
                    Mensaje('Eliminar Persona', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Eliminar Persona', JSON.stringify(error.response.data.message));
                } else {
                    Mensaje('Error', 'Ocurrió un error al eliminar la persona.');
                }
                console.error('Error al eliminar persona:', error);
            })
            .finally(() => {
                setCargando(false);
            });
    }
    async function ConsultarDocumento(identificacion){
        await ConsultarPersonaDocumento({obj: {per_idpersona: identificacion}, token: token})
        .then((response) => {
            console.log('Respuesta de ConsultarPersonaDocumento:', response);
            
            setValue('tipodocumento', response.data.personas[0].perTipoid);
            setValue('primernombre', response.data.personas[0].perNombre1);
            setValue('segundonombre', response.data.personas[0].perNombre2);
            setValue('primerapellido', response.data.personas[0].perApellido1);
            setValue('segundoapellido', response.data.personas[0].perApellido2);
            setValue('perPaisorigen', response.data.personas[0].perPaisorigen || '');
            setValue('perIdParentesco', response.data.personas[0].perIdParentesco || '');
            setValue('perFechanac', response.data.personas[0].fechanacimiento ? moment(response.data.personas[0].fechanacimiento).format('YYYY-MM-DD') : '');
            setValue('perSexo', response.data.personas[0].perSexo || '');
        })
        .catch((error) => { 
            console.error('Error al consultar documento:', error);
        });
        
        
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Formulario albergue"
                idCabezaFamilia="1"
                url={'/albergues/permanenciaalbergue'}
                nombreurl="Permanencia albergues"
                nombreform="Formulario albergue"/>
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <form className="form-horizontal" onSubmit={handleSubmit(saveFamilia)}>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h3">Formulario albergue</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('usrId')}/>
                                    <input hidden {...register('nucleoingreso')}/>
                                    <input hidden {...register('nucleovivanto')}/>
                                    <input hidden {...register('lugardeclaracion')}/>
                                    <Row>
                                        <Col sm={3}>
                                        <label htmlFor="fudFicha" className="me-2">FUD</label>
                                        <InputGroup>
                                            <input id="fudFicha" className="form-control" 
                                                {...register('fudFicha', { required: true })}
                                                placeholder="FUD"
                                                name="fudFicha"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                    setValue('fudFicha', value); // Update the value in the form
                                                    }}/>
                                            <Button onClick={e => {
                                                const value = e.target.closest('.input-group').querySelector('input').value;
                                                buscaDeclaracion(value);
                                            }}>
                                                <FaSearch />
                                            </Button>
                                        </InputGroup>
                                        {errors.fudFicha && <p style={{color: 'red'}}>Digite el FUD</p>}
                                        </Col>
                                        <Col sm={2}>
                                            <div className="form-group" >
                                                <label htmlFor="tipodocumento">Tipo de identificaci&oacute;n</label>
                                                <select id="tipodocumento" className='form-control' 
                                                    {...register('tipodocumento', { required: true })}
                                                    >
                                                    <option value="">Seleccionar</option>
                                                    {tipoDocumentos.map(opt => (
                                                        <option key={opt.id} value={opt.id}>{opt.tipTipoidentificacion}-{opt.tipDescripcion}</option>
                                                    ))}
                                                </select>
                                                {errors.tipodocumento && <p style={{color: 'red'}}>Seleccionar tipo identificaci&oacute;n</p>}
                                            </div>
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="documento">Documento</label>
                                            <input 
                                                id="documento" 
                                                {...register('documento', { 
                                                    required: "Digite Identificación",
                                                    validate: value => value && value !== "0" ? true : "La identificación no puede ser 0 ni estar vacía"
                                                })}  
                                                className="form-control" 
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                    setValue('documento', value); // Update the value in the form
                                                }}
                                                onBlur={(e) => {
                                                    ConsultarDocumento(e.target.value);
                                                }}
                                                placeholder="documento"
                                            />
                                            {errors.documento && <p style={{color: 'red'}}>{errors.documento.message}</p>}
                                        </Col>
                                        <Col sm={3}>
                                            <div className="form-group" >
                                                <label htmlFor="perPaisorigen">Pais origen</label>
                                                <select id="perPaisorigen" className='form-control' {...register('perPaisorigen', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {paises.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.iso} - {option.pais}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perPaisorigen && <p style={{color: 'red'}}>Seleccione pais origen</p>}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row hidden>
                                        <Col sm={6}>
                                        <b>Acta Ingreso: </b><FormControl
                                            type="file"
                                            accept=".pdf"
                                            value={scannedCedula}
                                            onChange={e => setScannedCedula(e.target.value)}
                                        />
                                        </Col>
                                        <Col sm={6}>
                                        <b>Acta Salida: </b><FormControl
                                            type="file"
                                            accept=".pdf"
                                            value={actaSalida}
                                            onChange={e => setActaSalida(e.target.value)}
                                        />
                                        </Col>
                                        {watch('scannedCedula') !== '0' && (
                                        <Col>
                                            Acta ingreso - {watch('documento')}
                                            <Button size="sm" onClick={() => verImagen(watch('id'), watch('documento'))}>Descarga</Button>                            </Col>
                                        )}
                                        {watch('actaSalida') !== '0' && (
                                        <Col>
                                            Acta salida - {watch('documento')}
                                            <Button size="sm" onClick={() => verImgSalida(watch('id'), watch('documento'))}>Descargar</Button>
                                        </Col>
                                        )}
                                    </Row>
                                    <Row>
                                        <Col><h4>Nombres y apellidos</h4></Col>
                                    </Row>
                                    <Row>
                                        <Col sm={3}>
                                            <label htmlFor="primernombre">Primer nombre</label>
                                            <input id="primernombre" className="form-control" 
                                                {...register('primernombre', { required: true })}
                                                placeholder="primer nombre"
                                                name="primernombre"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z0-9 ]/g, ''); // Remove non-alphanumeric characters
                                                    setValue('primernombre', value); // Update the value in the form
                                                }}/>
                                            {errors.primernombre && <p style={{color: 'red'}}>Digite primer nombre</p>}   
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="segundonombre">Segundo nombre</label>
                                            <input id="segundonombre" className="form-control" 
                                                {...register('segundonombre')}
                                                placeholder="segundo nombre"
                                                name="segundonombre"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z0-9 ]/g, ''); // Remove non-alphanumeric characters
                                                    setValue('segundonombre', value); // Update the value in the form
                                                }}/>
                                            {errors.segundonombre && <p style={{color: 'red'}}>Digite segundo nombre</p>}                                        
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="primerapellido">Primer apellido</label>
                                            <input id="primerapellido" className="form-control" 
                                                {...register('primerapellido', { required: true })}
                                                placeholder="primer apellido"
                                                name="primerapellido"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z0-9 ]/g, ''); // Remove non-alphanumeric characters
                                                    setValue('primerapellido', value); // Update the value in the form
                                                }}/>
                                            {errors.primerapellido && <p style={{color: 'red'}}>Digite primer apellido</p>}
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="segundoapellido">Segundo apellido</label>
                                            <input id="segundoapellido" className="form-control" 
                                                {...register('segundoapellido')}
                                                placeholder="segundo apellido"
                                                name="segundoapellido"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^A-Za-z0-9 ]/g, ''); // Remove non-alphanumeric characters
                                                    setValue('segundoapellido', value); // Update the value in the form
                                                }}/>
                                            {errors.segundoapellido && <p style={{color: 'red'}}>Digite segundo apellido</p>}
                                        </Col>
                                        <Col sm={3}>
                                            <div className="form-group" >
                                                <label htmlFor="perIdParentesco">Parentesco</label>
                                                <select
                                                    id="perIdParentesco"
                                                    {...register('perIdParentesco', {
                                                        required: true,
                                                        validate: value => value === "1" ? true : "Solo se permite seleccionar el Jefe de hogar"
                                                    })}
                                                    className='form-control'
                                                >
                                                    <option value="">Seleccionar</option>
                                                    {parentescos.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.par_parentesco}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.perIdParentesco && <p style={{color: 'red'}}>{errors.perIdParentesco.message}</p>}
                                            </div>
                                        </Col>
                                        <Col sm={2}>
                                            <div className="form-group">
                                                <label htmlFor="perFechanac">Fecha Nacimiento</label>
                                                <Controller
                                                    control={control}
                                                    name="perFechanac"
                                                    rules={{ required: "Seleccione fecha nacimiento" }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => {field.onChange(date);}}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.perFechanac && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                            </div>
                                        </Col>
                                        <Col sm={3}>
                                            <div className="form-group" >
                                                <label htmlFor="perSexo">Sexo</label>
                                                <select id="perSexo" className='form-control' {...register('perSexo', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {sexo.map((option) => (
                                                    <option key={option.sex_nombre} value={option.sex_nombre}>
                                                        {option.sex_nombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perSexo && <p style={{color: 'red'}}>Seleccione sexo</p>}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-center">                                        
                                        <Col sm={3}>
                                                <label htmlFor="estadovictima">VIVANTO</label>
                                                <select id="estadovictima" className='form-control' 
                                                    {...register('estadovictima', { required: true })}
                                                    onChange={(e) => {
                                                        setValue('otraaltavulnerabilidadremisiones', e.target.value === "1" ? 'SI' : '');
                                                    }}
                                                >
                                                        <option value="">Seleccione</option>
                                                         {estadosVictima.map(opt => (
                                                            <option key={opt.id} value={opt.id}>{opt.est_estado}</option>
                                                            ))}
                                                </select>
                                                {errors.estadovictima && <p style={{color: 'red'}}>Seleccionar estado</p>}
                                        
                                        </Col>
                                        <Col>
                                            <div className="form-group">
                                                <label htmlFor="fechaestado">Fecha declaraci&oacute;n o Valoraci&oacute;n</label>
                                                <div>
                                                    <Controller
                                                        control={control}
                                                        name="fechaestado"
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                <DatePicker
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                                {errors.fechaestado && <p style={{color: 'red'}}>Digite fecha registro victima</p>}
                                            </div>
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row className="justify-content-center">
                                        <Col>Ingreso por alta vulnerabilidad y/o remision otras instituciones</Col>
                                        <Col>
                                            <select id="otraaltavulnerabilidadremisiones" className='form-control' 
                                                {...register('otraaltavulnerabilidadremisiones')}
                                                disabled={true}
                                            >
                                                <option value="">Seleccione</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.otraaltavulnerabilidadremisiones && <p style={{color: 'red'}}>Seleccionar estado</p>}
                                        </Col>
                                    </Row>
                                
                            </Card.Body>
                            <Card.Footer>
                                <Row>
                                    <Col className="text-center">
                                        <Button disabled={cargando} className="btn btn-primary" type="submit">Guardar</Button>
                                    </Col>
                                    {idFamilia != 0 && <Col className="text-center">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                resetForm();
                                                navigate(`/albergues/crearpersona/${idFamilia}/0`);
                                            }}
                                            >
                                            Nueva persona
                                        </Button>
                                    </Col>}
                                    {idFamilia != 0 && <Col className="text-center">
                                        <a
                                            href={`/albergues/Registroalbergue/${idFamilia}/0`}
                                            className="btn btn-primary"
                                        >
                                            V&iacute;a gubernativa
                                        </a>
                                    </Col>}
                                    <Col className="text-center">
                                         <a
                                            href="/albergues/albergue/0"
                                            data-tooltip-id="tooltiparriba"
                                            data-tooltip-content="Registrar atencion albergue"
                                            className="btn btn-primary"
                                            type="button"
                                        >
                                            Registrar atenci&oacute;n manual
                                        </a>
                                    </Col>  
                                    <Col className="text-center">
                                        <Button className="btn btn-primary" onClick={cancelarFamilia}>Volver a men&uacute;</Button>
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </form>
                    <Card>
                        <Card.Header>
                            <Card.Title as="h3">Listado de personas</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Tipo Documento</th>
                                        <th>Documento</th>
                                        <th>Nombres y Apellidos</th>
                                        <th>Fecha Ingreso</th>
                                        <th>Fecha Salida</th>
                                        <th>Parentesco</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    
                                    {personas.length > 0 && personas.map((persona, index) => (
                                        <tr key={index}>
                                            <td>{persona.tip_tipoidentificacion}</td>
                                            <td>{persona.documento}</td>
                                            <td>
                                                {persona.primernombre} {persona.segundonombre} {persona.primerapellido} {persona.segundoapellido}
                                            </td>
                                            <td>{persona.fechaingreso ? persona.fechaingreso : ''}</td>
                                            <td>{persona.fechasalida ? persona.fechasalida : 'Permanece'}</td>
                                            <td>{persona.parentescopersona || ''}</td>
                                            <td>
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={() => navigate(`/albergues/crearpersona/${idFamilia}/${persona.id}`)}
                                                >
                                                    Editar
                                                </Button>
                                                {rol === '2' && (
                                                <Button
                                                    size="sm"
                                                    variant="danger"
                                                    onClick={() => {
                                                        setSwalProps({
                                                            show: true, // <-- Esto es necesario para mostrar el modal
                                                            icon: 'warning',
                                                            title: 'Confirmar',
                                                            text: '¿Está seguro de eliminar esta persona?',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Eliminar',
                                                            cancelButtonText: 'Cancelar',
                                                            preConfirm: () => EliminarPersona(persona.id)
                                                        });
                                                    }}
                                                >
                                                    Eliminar
                                                </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => {
                        setSwalProps({});
                        if (redirectId) {
                            navigate(`/albergues/formularioalbergue/${redirectId}`);
                            setRedirectId(null);
                        }
                    }}
                />
            </section>
        </div>
    );
}